import { jman } from '@/services/jman'
import { JManErrorNetworkError } from '@/assets/js/JMan/JManError'

export default {

	state: {
		error: null,
		refreshFrequency: 10000,
		lastUpdate: 0,
		taskId: null,
		online: null,
		lastPolled: null
	},

	mutations: {

		setError (state, error) {
			state.error = error;
		},

		setFrequency (state, frequency) {
			state.refreshFrequency = Math.max(frequency, 1000);
		},

		setLastUpdate (state, tstamp) {
			state.lastUpdate = tstamp;
		},

		setTaskId (state, taskId) {
			state.taskId = taskId;
		},

		setOnline (state, online) {
			state.online = online;
		},

		refreshLastPolled (state) {
			state.lastPolled = Date.now();
		}

	},

	actions: {

		async readFromNetwork ({state, commit}) {
			let online = true;
			let rows = [];

			try {
				rows = await jman.entities({modifiedSince: state.lastUpdate, cache: true, raw: true});
				commit('refreshLastPolled')
			} catch (err) {
				if (err instanceof JManErrorNetworkError) {
					online = false;
				}
			}

			const lastModified = rows
				.map(row => { return row.updatedOn })
				.sort()
				.pop();

			if (lastModified) {
				commit('setLastUpdate', lastModified);
			}

			commit('setOnline', online);
		},

		async startRefresh ({state, commit, dispatch}, frequency) {
			if (frequency) {
				commit('setFrequency', frequency);
			}

			if (state.taskId) {
				await dispatch('stopRefresh');
			}

			const taskId = setInterval( async () => {
				dispatch('readFromNetwork');
			}, state.refreshFrequency);

			commit('setTaskId', taskId);
		},

		async stopRefresh ({state, commit}) {
			if (state.taskId) {
				clearInterval(state.taskId);
				commit('setTaskId', null);
			}
		}
	},

	namespaced: true
};



// WEBPACK FOOTER //
// ./src/store/modules/dbsync.js